import { render, staticRenderFns } from "./PotentialTrades.vue?vue&type=template&id=79252ab9&scoped=true"
import script from "./PotentialTrades.vue?vue&type=script&lang=ts"
export * from "./PotentialTrades.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79252ab9",
  null
  
)

export default component.exports